/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


const quoteButtonTranslations = {
  pl: 'Wycena',
  cs: 'Cenová nabídka',
  de: 'Angebot',
  en: 'Quote',
  sk: 'Cenová ponuka',
};

function getLang() {
  return (Shopify?.locale || document.documentElement.lang || 'pl').slice(0, 2);
}

function translateBtn(btn) {
  const lang = getLang();
  const label = quoteButtonTranslations[lang] || quoteButtonTranslations['pl'];
  const countMatch = btn.textContent.match(/\(\d+\)/);
  const count = countMatch ? ' ' + countMatch[0] : '';
  const newText = label + count;

  // Nie nadpisuj jeśli tekst już prawidłowy (unikamy pętli mutacji)
  if (btn.textContent.trim() === newText.trim()) return;
  btn.textContent = newText;
}

// Obserwuj cały body — czekaj aż aplikacja wstawi przycisk
const bodyObserver = new MutationObserver(() => {
  const btn = document.querySelector('.omgrfq_view_quote_btn');
  if (!btn) return;

  translateBtn(btn);

  // Gdy przycisk już istnieje, obserwuj tylko jego zmiany (licznik)
  const btnObserver = new MutationObserver(() => translateBtn(btn));
  btnObserver.observe(btn, { childList: true, subtree: true, characterData: true });

  // Możemy przestać obserwować body
  bodyObserver.disconnect();
});

document.addEventListener('DOMContentLoaded', () => {
  bodyObserver.observe(document.body, { childList: true, subtree: true });
});